import { RankAccessor, StandingsViewTypeLabel } from './enums';

export const StandingsViews = {
    division: {
        label: StandingsViewTypeLabel.division,
        rankAccessor: RankAccessor.division,
    },
    wildcard: {
        label: StandingsViewTypeLabel.wildcard,
        rankAccessor: RankAccessor.wildcard,
    },
    conference: {
        label: StandingsViewTypeLabel.conference,
        rankAccessor: RankAccessor.conference,
    },
    league: {
        label: StandingsViewTypeLabel.league,
        rankAccessor: RankAccessor.league,
    },
};

export const STANDINGS_INITIAL_SORT = [{ id: 'points', desc: true }];
